/**
 * Ad-platform IDs for our own marketing site (askflow.sa). These are public
 * identifiers that ship in the page source anyway, so they are constants, not
 * env vars. Secrets (the Conversions API token) stay in env.
 *
 * Tenant sites have their own per-tenant analytics (packages/analytics/tenant);
 * nothing here may be mounted on a tenant route.
 */
export const MARKETING_TRACKING = {
  metaPixelId: '1985526512845848',
  ga4MeasurementId: 'G-D9Y5YDC8RB',
  googleAdsId: 'AW-18544637820',
  googleAdsLeadLabel: '5Lf2CMiUtK4dEPzu4opF',
  linkedInPartnerId: '9957594',
} as const;

/**
 * Events the marketing site reports. `Lead` is reserved for a submitted
 * contact form (the only step where we know who the visitor is); opening the
 * demo scheduler is intent, so it reports `Contact`. A real `Schedule` needs
 * the booking itself, which the cross-origin Google Calendar frame hides.
 */
export const MARKETING_BROWSER_EVENTS = ['PageView', 'ViewContent', 'Contact'] as const;

export type MarketingBrowserEvent = (typeof MARKETING_BROWSER_EVENTS)[number];

export type MarketingEvent = MarketingBrowserEvent | 'Lead';

/** Paths whose visit counts as content interest for ad optimisation. */
const VIEW_CONTENT_PREFIXES = [
  '/compare',
  '/best',
  '/booking-software',
  '/guides',
  '/padel-software',
  '/gym-software',
  '/pilates-studio-software',
  '/academy-software',
  '/customers',
];

export function isViewContentPath(pathname: string): boolean {
  const path = pathname.replace(/^\/ar(?=\/|$)/, '') || '/';

  return VIEW_CONTENT_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
